import mutations from './otherBillableItems.mutations'
import actions from './otherBillableItems.actions'
import getters from './otherBillableItems.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
